import React from 'react'
import LtsChips from '../../../components/lottus/lts-chips'
import storage from '../../../services/stoage.service'
import utils from '../../../utils'
import './ConfigRetornoChipsField.scss'

/**
 * Componente para editar um campo com Chips (array de strings livre)
 *
 * @param {Array} props.value - Array de valores
 * @param {Function} props.onChange - Callback chamado quando o valor é alterado
 * @param {string} props.title - Título do campo (h5)
 * @param {string} props.name - Nome do campo
 * @param {string} props.label - Label do input
 * @param {string} props.error - Mensagem de erro de validação
 * @param {string} props.separator - Separador para adicionar múltiplos valores (ex: ',')
 * @param {number} props.max - Número máximo de itens
 * @param {boolean} props.allowDuplicate - Permite valores duplicados
 * @returns {JSX.Element}
 */
export default function ConfigRetornoChipsField(props) {
  const {
    value = [],
    onChange,
    title,
    name,
    label,
    error,
    separator,
    max,
    allowDuplicate = false,
  } = props

  const handleChange = (newValue) => {
    onChange?.(newValue)
  }

  return (
    <div className="config-retorno-chips-field">
      <div className="card card-w-title">
        <h5>{title}</h5>

        <div className="form-group">
          <LtsChips
            value={value}
            onChange={(e) => handleChange(e)}
            name={name}
            label={label}
            separator={separator}
            max={max}
            allowDuplicate={allowDuplicate}
            className={error ? 'p-invalid' : ''}
          />
          {error && <small className="p-error">{error}</small>}
        </div>
      </div>
    </div>
  )
}
